<hsg-modal>
  <span class="title">עדכן את הסיסמה שלך</span>
  <div class="body" ngForm #changePassword="ngForm" (ngSubmit)="submit(changePassword)" (keyup.enter)="changePassword.onSubmit()">

    <p>
      שדות בטופס המסומנים בכוכבית הינם שדות חובה
     <span class="asterix">*</span>
      </p>       

    <div class="h-gr h-gr--nowrap">

            <div class="c-column-logo">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 128 128">
                  <path d="M90.6,77.5c-1.4,0-2.5,1.1-2.5,2.5v32.8c0,2-1.7,3.7-3.7,3.7H15.3c-2.1,0-3.8-1.7-3.8-3.8v-80h18.8
                    c0.7,0,1.3-0.3,1.8-0.7s0.7-1.1,0.7-1.8l0-18.8h51.6c2.1,0,3.8,1.7,3.8,3.8v7.9c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-7.9
                    c0-4.8-3.9-8.7-8.7-8.7H30.3c-0.2,0-0.3,0-0.5,0c0,0,0,0,0,0c-0.2,0-0.4,0.1-0.6,0.2c0,0-0.1,0-0.1,0.1c-0.2,0.1-0.4,0.2-0.5,0.4
                    L7.2,28.5c-0.2,0.2-0.3,0.3-0.4,0.5c0,0-0.1,0.1-0.1,0.1c-0.1,0.2-0.2,0.4-0.2,0.6c0,0,0,0,0,0c0,0.2,0,0.3,0,0.5v82.4
                    c0,4.8,3.9,8.7,8.7,8.7h69.2c4.8,0,8.7-3.9,8.7-8.7V80C93.1,78.6,92,77.5,90.6,77.5z M15,27.8L27.8,15l0,12.8H15z"/>
                  <path d="M54.1,58.7c0-1.4-1.1-2.5-2.5-2.5H23.2c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h28.4
                    C53,61.2,54.1,60,54.1,58.7z"/>
                  <path d="M68.3,48c0-1.4-1.1-2.5-2.5-2.5H23.2c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h42.6
                    C67.1,50.5,68.3,49.4,68.3,48z"/>
                  <path d="M37.4,110.8h35.5c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5H37.4c-1.4,0-2.5,1.1-2.5,2.5S36,110.8,37.4,110.8z"/>
                  <path d="M121.5,30.7c0-5.5-4.5-10-10-10c-2.7,0-5.2,1-7.1,2.9l-51,51c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.1,0.1-0.2,0.2
                    C53.1,75,53,75.1,53,75.2c0,0-0.1,0.1-0.1,0.1L42.3,96.6c-0.5,1-0.3,2.1,0.5,2.9c0.5,0.5,1.1,0.7,1.8,0.7c0.4,0,0.8-0.1,1.1-0.3
                    l21.3-10.6c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1-0.1,0.2-0.2c0,0,0.1-0.1,0.1-0.1l49.7-49.7c0,0,0,0,0,0s0,0,0,0
                    l1.3-1.3C120.4,35.9,121.5,33.4,121.5,30.7z M116.5,30.7c0,1.1-0.4,2.2-1.1,3.1l-7.1-7.1c0.9-0.7,2-1.1,3.1-1.1
                    C114.3,25.7,116.5,27.9,116.5,30.7z M110.1,39.2l-7.1-7.1l1.8-1.8l7.1,7.1L110.1,39.2z M99.5,35.6l7.1,7.1L65.8,83.6l-7.1-7.1
                    L99.5,35.6z M54.4,90l-2.2-2.2l3.6-7.1l5.8,5.8L54.4,90z"/>
                </svg>
               
            </div>

          <div class="h-cl">

        <p>
          תוקף סיסמתך עומד להסתיים. אנא בחר סיסמה חדשה. 
        </p>
        <p>הסיסמה צריכה לכלול לפחות 7 תווים (מספרים ואותיות באנגלית).</p>
        <div class="h-gr h-gr--column">
            <div class="h-cl">
                <hsg-field>
                  <input hsgInput type="password" name="pwOld" id="pwOld" aria-invalid="false"
                  ngModel required maxlength="25" pattern="^.{2,25}$" #pwOld="ngModel">
                  <label hsgLabel>הקלד את הסיסמה הנוכחית שלך</label>
                <div hsgError *ngIf="pwOld.invalid && changePassword.submitted" class="h-hero__formDanger">
                  <div hsgError *ngIf="pwOld?.errors?.required">
                    עליך להזין סיסמה
                  </div>
                  <div hsgError *ngIf="pwOld?.errors?.pattern">
                    עליך להזין סיסמה תקינה בין 2 ל- 25 תווים
                  </div>
                </div>
                </hsg-field>
              </div>
          <div class="h-cl">
            <hsg-field>
              <input hsgInput type="password" name="pwNew" id="pwNew" ngModel aria-invalid="false"
                required maxlength="25"  [equelValueValidator]="pwValidate" [caseSensitive]="'true'"
                #pwNew="ngModel">
                <!-- pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{7,15}$" -->
                <label hsgLabel>הקלד את הסיסמה החדשה שלך</label>
              <div hsgError *ngIf="pwNew.invalid && changePassword.submitted" class="h-hero__formDanger">
                <div hsgError *ngIf="pwNew?.errors?.required">
                  עליך להזין סיסמה
                </div>
                <!-- <div hsgError *ngIf="pwNew?.errors?.pattern">
                  יש להקליד סיסמא המכילה 7-15 אותיות לועזיות קטנות, גדולות, מספרים. על הסיסמא להכיל לפחות תו אחד מכל סוג, ולא הייתה בשימוש ב-10 הסיסמאות הקודמות שלך.
                </div> -->
              </div>
            </hsg-field>
          </div>
          <div class="h-cl">
              <hsg-field>
                <input hsgInput type="password" name="pwValidate" id="pwValidate" aria-invalid="false"
                 ngModel required maxlength="25" [equelValueValidator]="pwNew" [caseSensitive]="'true'"
                #pwValidate="ngModel">
                <label hsgLabel>הקלד שוב את הסיסמה החדשה שלך</label>
              <div hsgError *ngIf="pwValidate.invalid && changePassword.submitted" class="h-hero__formDanger">
                <div hsgError *ngIf="pwValidate?.errors?.required">
                  יש למלא סיסמא
                </div>
                <div hsgError *ngIf="pwValidate?.errors?.equelValue && !pwValidate?.errors?.required">
                  נא להזין סיסמאות תואמות
                </div>
              </div>
              </hsg-field>
            </div>
        </div>
        <div hsgError *ngIf="serverError">
          {{serverError}}
        </div>
        <br>
        <ngx-invisible-recaptcha *ngIf="showCaptcha" #captchaElem  [hl]="'he'" (ready)="captchaReady()" (success)="captchaSuccess($event)" [type]="'image'" [badge]="'inline'">
          </ngx-invisible-recaptcha>
      </div>
    </div>
  </div>
  <div class="actions">
    <button hsg-button kind="primary" (click)="changePassword.onSubmit()" [disabled]="pending">המשך
      <hsg-spinner *ngIf="pending" class="u-mr-s"></hsg-spinner>
    </button>
  </div>
</hsg-modal>